
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 80 80"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"40","cy":"42.6","r":"24","fill":"#56CCF2"}}),_c('path',{attrs:{"stroke":"#2F80ED","stroke-width":"4","d":"M67.2 37c0-13.25-12.18-24-27.2-24S12.8 23.75 12.8 37"}}),_c('rect',{attrs:{"width":"9.6","height":"19.2","x":"62.4","y":"35.4","fill":"#fff","stroke":"#fff","stroke-width":"4","rx":"4.8"}}),_c('rect',{attrs:{"width":"9.6","height":"19.2","x":"8","y":"35.4","fill":"#fff","stroke":"#fff","stroke-width":"4","rx":"4.8"}}),_c('rect',{attrs:{"width":"9.6","height":"19.2","x":"8","y":"35.4","fill":"#2F80ED","rx":"4.8"}}),_c('path',{attrs:{"fill":"#fff","d":"M44 61.8a4 4 0 110-8h4a4 4 0 010 8h-4z"}}),_c('path',{attrs:{"fill":"#fff","d":"M65.6 53.2l-2-1.8c-2.88 4.32-10.53 4.92-14 4.68v2.52c10.88 0 15.2-3.6 16-5.4z"}}),_c('path',{attrs:{"stroke":"#fff","stroke-width":"4","d":"M44 61.8a4 4 0 110-8h4a4 4 0 010 8h-4z"}}),_c('path',{attrs:{"stroke":"#fff","stroke-width":"4","d":"M65.6 53.2l-2-1.8c-2.88 4.32-10.53 4.92-14 4.68v2.52c10.88 0 15.2-3.6 16-5.4z"}}),_c('rect',{attrs:{"width":"9.6","height":"19.2","x":"62.4","y":"35.4","fill":"#2F80ED","rx":"4.8"}}),_c('rect',{attrs:{"width":"8","height":"12","x":"40","y":"61.8","fill":"#2F80ED","rx":"4","transform":"rotate(-90 40 61.8)"}}),_c('path',{attrs:{"fill":"#2F80ED","d":"M65.6 53.2l-2-1.8c-2.88 4.32-10.53 4.92-14 4.68v2.52c10.88 0 15.2-3.6 16-5.4z"}})])
          )
        }
      }
    